/**
 * Todos los tipos de acciones que se pueden realizar en el contexto.
 */
export const STATE_INICIAL = 'STATE_INICIAL';
export const INICIAR_SESION = 'INICIAR_SESION';
export const OBTENER_TODOS_JUGADORES = 'OBTENER_TODOS_JUGADORES';
export const OBTENER_LOCALIDADES = 'OBTENER_LOCALIDADES';
export const OBTENER_NOMBRES_LOCALIDADES = 'OBTENER_NOMBRES_LOCALIDADES';
export const OBTENER_LISTAS = 'OBTENER_LISTAS';
export const OBTENER_LISTAS_ACCESIBLES = 'OBTENER_LISTAS_ACCESIBLES';
export const MODIFICAR_TEMPORADA = 'MODIFICAR_TEMPORADA';
export const MODIFICAR_CATEGORIA = 'MODIFICAR_CATEGORIA';
export const MODIFICAR_DIVISION = 'MODIFICAR_DIVISION';
export const MODIFICAR_GRUPO = 'MODIFICAR_GRUPO';

/**
 * Reducer que maneja las acciones del contexto.
 */
const reducer = (state, action) => {
  switch (action.type) {
    case STATE_INICIAL:
      return action.payload;

    // Comun
    case INICIAR_SESION:
      return {
        ...state,
        idUsuario: action.payload.idUsuario,
        usuarioNombre: action.payload.nombre,
        idClub: action.payload.idClub,
        clubNombre: action.payload.nombreClub,
      };

    case OBTENER_TODOS_JUGADORES:
      return { ...state, todosJugadores: action.payload };

    case OBTENER_LOCALIDADES:
      return { ...state, localidades: action.payload };

    case OBTENER_NOMBRES_LOCALIDADES:
      return { ...state, nombresLocalidades: action.payload };

    case OBTENER_LISTAS:
      return { ...state, listas: action.payload };

    case OBTENER_LISTAS_ACCESIBLES:
      return { ...state, listasAccesibles: action.payload };

    // Buscador
    case MODIFICAR_TEMPORADA:
      return { ...state, temporada: action.payload };

    case MODIFICAR_CATEGORIA:
      return { ...state, categoria: action.payload };

    case MODIFICAR_DIVISION:
      return { ...state, division: action.payload };

    case MODIFICAR_GRUPO:
      return { ...state, grupo: action.payload };

    default:
      return state;
  }
};

export default reducer;
